import React from 'react'
import { createStreamWidgetDataFromDocumentRetrieval } from 'components/widget/StreamWidgets/share/Stream/createStreamWidgetDataFromDocumentRetrieval'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { Soundbite } from 'components/widget/StreamWidgets/share/Stream/Soundbite'
import Deleted from 'components/widget/StreamWidgets/share/Stream/Deleted'
import { useSoundbites } from './hooks'

type LinkItemSoundbiteProps = {
  url?: string
  widgetId: number
}

const LinkItemSoundbite = ({ url, widgetId }: LinkItemSoundbiteProps) => {
  const documentRetrievalResult = useSoundbites(widgetId, url)?.soundbitesData
  const { timeZone } = usePageConfigUser()

  const {
    soundbites,
    deletedSentenceCount,
    deletedSentenceDateRangeFrom,
    deletedSentenceDateRangeTo
  } = createStreamWidgetDataFromDocumentRetrieval(documentRetrievalResult, timeZone)

  const unDeletedSoundbites = soundbites.filter((soundbite) => !soundbite.deleted)
  const unDeletedSoundbitesLength = unDeletedSoundbites.length

  return (
    <>
      {unDeletedSoundbites.map((soundbite, index) => {
        const { documentId } = soundbite
        const key = `${documentId}-${index}`
        return (
          <Soundbite widgetId={widgetId} streamData={soundbite} key={key} serialNumber={index} />
        )
      })}
      <Deleted
        deletedSentenceCount={deletedSentenceCount}
        deletedSentenceDateRangeFrom={deletedSentenceDateRangeFrom!}
        deletedSentenceDateRangeTo={deletedSentenceDateRangeTo!}
        serialNumber={unDeletedSoundbitesLength}
      />
    </>
  )
}

export default LinkItemSoundbite
